export default __webpack_public_path__ + "static/media/hotdog.7495687f.png";